namespace Nbs.Xlr8PageTemplate.Menu.MenuDom {
  export const mobileCollapsedClass = 'xpt-mobile-collapsed';
  export const openFlyoutTreeWait = 500;

  export function getMenuNavElement() {
    const navMenuElement = Utilities.getFirstElement('nbs-menu');
    if (navMenuElement?.firstChild?.nodeName.toUpperCase() === 'NAV') {
      return navMenuElement.firstChild as HTMLElement;
    }
    return undefined;
  }

  export function isMenuCollapsed() {
    const navElement = getMenuNavElement();
    if (navElement) {
      return Utilities.hasClass(navElement, mobileCollapsedClass);
    }
    return true;
  }

  export function isFlyoutMenuCollapsed() {
    if (Flyout.openFlyoutId) {
      const flyout = document.querySelector(`#xpt-flyout-menu-${Flyout.openFlyoutId}`) as HTMLElement;
      if (flyout) {
        return Utilities.hasClass(flyout, mobileCollapsedClass);
      }
    }
    return true;
  }

  export function toggleMenu() {
    const navElement = getMenuNavElement();
    if (navElement) {
      navElement.classList.toggle(mobileCollapsedClass);
    }

    if (Flyout.openFlyoutId) {
      Flyout.closeFlyoutMenu();
    }
  }

  export function closeMobileMenuFromBodyClick(event: MouseEvent) {
    if (Flyout.openFlyoutId) {
      Flyout.closeFlyoutHandler(event);
    } else {
      const menu = (event.target as HTMLElement).closest<HTMLElement>('nbs-menu');
      if (!menu && !isMenuCollapsed()) {
        toggleMenu();
        Header.HeaderMenuButton.updateIcon();
      }
    }
  }

  function getBadge(menuItemId: string, sub: string) {
    return document.querySelector(`[data-menu-item-id="${menuItemId}"]`)?.querySelector(sub);
  }

  export function setBadgeValue(menuItemId: string, value?: number) {
    const badgeElem = getBadge(menuItemId, '.xpt-menu-link-label-badge-value');
    if (badgeElem) {
      badgeElem.innerHTML = value?.toString() ?? '';
    }
  }

  export function setBadgeType(menuItemId: string, type: Navigation.BadgeType) {
    const badgeElem = getBadge(menuItemId, '.xpt-menu-link-label-badge-value');
    if (badgeElem) {
      const errorClass = 'xpt-menu-link-label-badge-value-error';
      if (type == 'error') {
        Utilities.addClass(badgeElem as HTMLElement, errorClass);
      } else {
        Utilities.removeClass(badgeElem as HTMLElement, errorClass);
      }
    }
  }

  export function setBadgeVisibility(menuItemId: string, isVisible: boolean) {
    const badgeElem = getBadge(menuItemId, '.xpt-menu-link-label-badge');
    if (badgeElem) {
      const hiddenClass = 'xpt-menu-link-label-badge-hidden';
      if (isVisible) {
        Utilities.removeClass(badgeElem as HTMLElement, hiddenClass);
      } else {
        Utilities.addClass(badgeElem as HTMLElement, hiddenClass);
      }
    }
  }

  export function setActiveMenuItem() {
    const navElement = getMenuNavElement();
    if (!navElement) {
      return;
    }

    const activeMenuItems = navElement.getElementsByClassName('xpt-active-menu-item');
    Array.prototype.forEach.call(activeMenuItems, (menuItem: HTMLElement) => {
      Utilities.removeClass(menuItem, 'xpt-active-menu-item');

      const anchorTag = menuItem.firstChild as HTMLElement;
      Utilities.removeAttribute(anchorTag, 'aria-current');

      // walk the parents and remove the active child class
      Utilities.findParent(menuItem.parentElement, element => {
        Utilities.removeClass(element, 'xpt-has-active-child');
        return element.tagName.toUpperCase() === 'NAV';
      });
    });

    const menuLiElements = navElement.getElementsByTagName('li');
    if (menuLiElements.length) {
      const activeMenuItemId = getActiveMenuItem();
      Array.prototype.forEach.call(menuLiElements, (menuItem: HTMLElement) => {
        const menuItemId = menuItem.getAttribute('data-menu-item-id');
        if (menuItemId && menuItemId === activeMenuItemId) {
          Utilities.addClass(menuItem, 'xpt-active-menu-item');

          const anchorTag = menuItem.firstChild as HTMLElement;
          Utilities.setAttribute(anchorTag, 'aria-current', 'page');

          // walk the parents and add the active child class and open the expander
          Utilities.findParent(menuItem.parentElement, element => {
            if (Utilities.hasClass(element, 'xpt-expander-menu-item')) {
              Utilities.addClass(element, 'xpt-has-active-child');
              setExpanderState(element, true);
            }
            return element.tagName.toUpperCase() === 'NAV';
          });
        }
      });
    }
  }

  function setExpanderState(expanderElement: HTMLElement, isOpen: boolean) {
    Utilities.removeClass(expanderElement, isOpen ? 'xpt-collapsed' : 'xpt-expanded');
    Utilities.addClass(expanderElement, isOpen ? 'xpt-expanded' : 'xpt-collapsed');

    const anchorElement = expanderElement.getElementsByTagName('a')[0];
    anchorElement.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    const expanderIconDivElement = anchorElement.querySelector('.xpt-menu-link-expander-icon') as HTMLDivElement;
    if (expanderIconDivElement) {
      const iconElement = expanderIconDivElement.firstChild as HTMLElement;
      iconElement.textContent = isOpen ? 'expand_less' : 'expand_more';
    } else {
      const iconDivElement = anchorElement.querySelector('.xpt-menu-link-icon') as HTMLDivElement;
      const iconElement = iconDivElement.firstChild as HTMLElement;
      iconElement.textContent = isOpen ? 'arrow_drop_up' : 'arrow_drop_down';
    }
  }

  export function toggleExpander(expanderElement: HTMLElement) {
    if (Utilities.hasClass(expanderElement, 'xpt-expanded')) {
      setExpanderState(expanderElement, false);
    } else {
      setExpanderState(expanderElement, true);
    }
  }

  export function disableTemporarilyFlyoutMenuItem(){
    const flyoutMenuItems = document.querySelectorAll('li.xpt-menu-link-item a[role="button"]');

    flyoutMenuItems.forEach(flyoutMenuItem => {
      if (flyoutMenuItem) {
        flyoutMenuItem.classList.add('no-clickable');

        setTimeout(() => {
          flyoutMenuItem.classList.remove('no-clickable');
        }, openFlyoutTreeWait);
      }
    });
  }
}
